module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [(_vm.viewFlag) ? _c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.cnpro.cnpro_name))])]), _vm._v(" "), _c('div', {
    staticClass: "stats-body"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.img_url + _vm.cnpro.cnpro_image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "stats-body"
  }, [_c('label', [_vm._v("Change Picture")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, _vm.cnpro.cnpro_id, 'cnpros')
      }
    }
  })]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "stats-body"
  }, [_c('label', [_vm._v("CNpro Total Job Done: " + _vm._s(_vm.cnpro.cnpro_jobs_done))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 stats-info stats-last widget-shadow"
  }, [_c('div', {
    staticClass: "notifications"
  }, [_c('header', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n                             Profile\r\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "notify-w3ls"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n                                \"paging\": {\r\n                                \"enabled\": true\r\n                                },\r\n                                \"filtering\": {\r\n                                \"enabled\": true\r\n                                },\r\n                                \"sorting\": {\r\n                                \"enabled\": true\r\n                                }}"
    }
  }, [(_vm.editRequest) ? _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_name),
      expression: "cnpro.cnpro_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Email")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_email),
      expression: "cnpro.cnpro_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Phone")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_phone),
      expression: "cnpro.cnpro_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Address")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_address),
      expression: "cnpro.cnpro_address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_address = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Service Description")]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_description),
      expression: "cnpro.cnpro_description"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.cnpro.cnpro_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Facebook")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_facebook),
      expression: "cnpro.cnpro_facebook"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_facebook)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_facebook = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Twitter")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_twitter),
      expression: "cnpro.cnpro_twitter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_twitter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_twitter = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Instagram")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cnpro.cnpro_instagram),
      expression: "cnpro.cnpro_instagram"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cnpro.cnpro_instagram)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cnpro.cnpro_instagram = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.editListing
    }
  }, [_vm._v("Save")])])])]) : _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpro.cnpro_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpro.cnpro_email))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("City")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpro.cnpro_city_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Phone")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpro.cnpro_phone))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Address")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpro.cnpro_address))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Service Description")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpro.cnpro_description))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Facebook")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpro.cnpro_facebook))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Twitter")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpro.cnpro_twitter))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Instagram")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpro.cnpro_instagram))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Status")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.cnpro.cnpro_status) + " \r\n                                        "), (_vm.cnpro.cnpro_status_id == 2) ? _c('span', [_c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.approveCnpro(_vm.cnpro.cnpro_id)
      }
    }
  }, [_vm._v("Approve")])]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.requests('edit')
      }
    }
  }, [_vm._v("Edit")]), _vm._v("  "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.requests('delete')
      }
    }
  }, [_vm._v("Delete")])])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), (_vm.deleteRequest) ? _c('td', [_c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to do this?")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-xs",
    on: {
      "click": _vm.deleteListing
    }
  }, [_vm._v("Yes Delete")]), _vm._v("\r\n                                           \r\n                                        "), _c('button', {
    staticClass: "btn btn-primary btn-xs",
    on: {
      "click": function($event) {
        _vm.requests('reset')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-12 stats-info widget"
  }, [_c('center', [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("CNpro Identity Card")])]), _vm._v(" "), _c('div', {
    staticClass: "stats-body"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.img_url + _vm.cnpro.cnpro_identity_card
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "stats-body"
  }, [_c('label', [_vm._v("Change Identity Card")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, _vm.cnpro.cnpro_id, 'cnpros_id_card')
      }
    }
  })])])])], 1)])]) : _c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "market-updates"
  }, [_c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('div', {
    staticClass: "market-update-block clr-block-2"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 market-update-left"
  }, [_c('h4', [_vm._v("CNpros")]), _vm._v(" "), (_vm.cnpros) ? _c('h3', [_vm._v(_vm._s(_vm.cnpros.length))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-agile-info"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n         cnpros Lists\r\n        ")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n            \"paging\": {\r\n              \"enabled\": true\r\n            },\r\n            \"filtering\": {\r\n              \"enabled\": true\r\n            },\r\n            \"sorting\": {\r\n              \"enabled\": true\r\n            }}"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.cnpros), function(cnpro, index) {
    return _c('tr', {
      attrs: {
        "data-expanded": "true"
      }
    }, [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpro.cnpro_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpro.cnpro_email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpro.cnpro_city_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpro.cnpro_phone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cnpro.cnpro_status))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          _vm.setPanel('view', cnpro)
        }
      }
    }, [_vm._v("View")])])])
  }))])])])])]), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 market-update-right"
  }, [_c('i', {
    staticClass: "fa fa-users"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("First Name")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("City")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-breakpoints": "xs sm md",
      "data-title": "DOB"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("~")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-115364ee"}!./src/components/Cnpros/template.html
// module id = 153
// module chunks = 0